import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tw-mb-7" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "tw-mb-2 tw-block tw-text-xs" }, "Chat Settings", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioDetailedSelect = _resolveComponent("StudioDetailedSelect")!
  const _component_StudioToggleWithLabel = _resolveComponent("StudioToggleWithLabel")!
  const _component_StudioInput = _resolveComponent("StudioInput")!
  const _component_ModuleWrapper = _resolveComponent("ModuleWrapper")!

  return (_openBlock(), _createBlock(_component_ModuleWrapper, {
    moduleId: _ctx.moduleId,
    title: "Chat Experience",
    onInitializeData: _ctx.initializeData
  }, {
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_StudioDetailedSelect, {
          options: _ctx.chatOptions,
          selectedOption: _ctx.selectedChatOption,
          onOnSelect: _ctx.handleChatVisiblityChange
        }, null, 8, ["options", "selectedOption", "onOnSelect"])
      ]),
      _createVNode(_component_StudioToggleWithLabel, {
        id: "session-chat-toggle",
        label: "Session Chat",
        subLabel: "Enable an additional chat thread specific to each session.",
        class: "tw-mb-7",
        checked: _ctx.broadcastChatEnabled,
        "onUpdate:checked": _ctx.handleBroadcastChatToggle
      }, null, 8, ["checked", "onUpdate:checked"]),
      (_ctx.organization.useNewChatApp)
        ? (_openBlock(), _createBlock(_component_StudioToggleWithLabel, {
            key: 0,
            id: "thread-chat-toggle",
            label: "Threaded Chat",
            subLabel: "Enable threaded conversations. Attendees can reply to specific messages and create conversation threads. This affects both Public and Session chat.",
            class: "tw-mb-7",
            checked: _ctx.threadChatEnabled,
            "onUpdate:checked": _ctx.handleThreadChatToggle
          }, null, 8, ["checked", "onUpdate:checked"]))
        : _createCommentVNode("", true),
      _createVNode(_component_StudioToggleWithLabel, {
        id: "p2p-chat-toggle",
        label: "Direct Message",
        subLabel: "Attendees can privately message other attendees, speakers, and organizers.",
        class: "tw-mb-7",
        checked: _ctx.p2pChatEnabled,
        "onUpdate:checked": _ctx.handleP2PChatToggle
      }, null, 8, ["checked", "onUpdate:checked"]),
      false
        ? (_openBlock(), _createBlock(_component_StudioToggleWithLabel, {
            key: 1,
            id: "text-qna-toggle",
            label: "Text Q&A",
            subLabel: "Attendees can ask questions and upvote other attendees' questions.",
            class: "tw-mb-7",
            checked: _ctx.hasTextQna,
            "onUpdate:checked": _ctx.handleTextQnaToggle
          }, null, 8, ["checked", "onUpdate:checked"]))
        : _createCommentVNode("", true),
      (_ctx.hasTextQna)
        ? (_openBlock(), _createBlock(_component_StudioToggleWithLabel, {
            key: 2,
            id: "text-qna-moderated-toggle",
            label: "Moderate Text Q&A",
            subLabel: "Require moderators to approve or reject questions before they are shown to the audience in the Q&A tab.",
            class: "tw-mb-7",
            checked: _ctx.textQnaModerated,
            "onUpdate:checked": _ctx.handleTextQnaModeratedToggle
          }, null, 8, ["checked", "onUpdate:checked"]))
        : _createCommentVNode("", true),
      (_ctx.hasTextQna && _ctx.organization.assignQnaToSpeaker)
        ? (_openBlock(), _createBlock(_component_StudioToggleWithLabel, {
            key: 3,
            id: "assign-qna-to-speaker-toggle",
            label: "Assign Questions from Q&A",
            subLabel: "Allow attendee questions in Q&A to be assigned to a specific speaker or staff.",
            class: "tw-mb-7",
            checked: _ctx.assignQnaToSpeaker,
            "onUpdate:checked": _ctx.handleAssignQnaToSpeakerToggle
          }, null, 8, ["checked", "onUpdate:checked"]))
        : _createCommentVNode("", true),
      (_ctx.hasTextQna)
        ? (_openBlock(), _createBlock(_component_StudioToggleWithLabel, {
            key: 4,
            id: "anonymous-qna-toggle",
            label: "Anonymous Text Q&A",
            subLabel: "Attendees can ask questions anonymously.",
            class: "tw-mb-7",
            checked: _ctx.anonymousQnaEnabled,
            "onUpdate:checked": _ctx.handleAnonymousQnaToggle
          }, null, 8, ["checked", "onUpdate:checked"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        (_ctx.hasTextQna)
          ? (_openBlock(), _createBlock(_component_StudioToggleWithLabel, {
              key: 0,
              id: "show-answerers-identity-toggle",
              label: "Show Answerers' Identity",
              subLabel: "Show the name of the person who answered the question.",
              class: "tw-mb-4",
              checked: _ctx.showAnswerersIdentity,
              "onUpdate:checked": _ctx.handleShowAnswerersIdentityToggle
            }, null, 8, ["checked", "onUpdate:checked"]))
          : _createCommentVNode("", true),
        (_ctx.hasTextQna && _ctx.showAnswerersIdentity)
          ? (_openBlock(), _createBlock(_component_StudioInput, {
              key: 1,
              id: "textqna-answerers-alias-input",
              label: "Answerers' Alias",
              class: "tw-mb-7",
              modelValue: _ctx.textqnaAnswerersAlias,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = value => _ctx.editTextqnaAnswerersAlias(value))
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ]),
      false
        ? (_openBlock(), _createBlock(_component_StudioToggleWithLabel, {
            key: 5,
            id: "video-qna-toggle",
            label: "Video Q&A",
            subLabel: "Attendees can ask questions and upvote other attendees' questions.",
            class: "tw-mb-7",
            checked: _ctx.hasVideoQna,
            "onUpdate:checked": _ctx.handleVideoQnaToggle
          }, null, 8, ["checked", "onUpdate:checked"]))
        : _createCommentVNode("", true),
      _createVNode(_component_StudioToggleWithLabel, {
        id: "gifs-toggle",
        label: "GIFs",
        subLabel: "Attendees can send GIFs in chat.",
        class: "tw-mb-7",
        checked: _ctx.gifsEnabled,
        "onUpdate:checked": _ctx.handleGifsEnabledToggle
      }, null, 8, ["checked", "onUpdate:checked"]),
      (_ctx.organization.useFloatingEmoji)
        ? (_openBlock(), _createBlock(_component_StudioToggleWithLabel, {
            key: 6,
            id: "floating-emoji-reactions-toggle",
            label: "Floating Emoji Reactions",
            subLabel: "Attendees can engage by tapping emojis that float over the stage, giving speakers instant real-time feedback.",
            class: "tw-mb-7",
            checked: _ctx.floatingEmojiReactionsEnabled,
            "onUpdate:checked": _ctx.handleFloatingEmojiReactionsToggle
          }, null, 8, ["checked", "onUpdate:checked"]))
        : _createCommentVNode("", true),
      _createVNode(_component_StudioToggleWithLabel, {
        id: "discussions-chat-toggle",
        label: "Room Chat",
        subLabel: "Attendees can chat with other attendees in Rooms.",
        class: "tw-mb-7",
        checked: _ctx.discussionsChatEnabled,
        "onUpdate:checked": _ctx.handleDiscussionsChatToggle
      }, null, 8, ["checked", "onUpdate:checked"]),
      (_ctx.isBoothsTabEnabled)
        ? (_openBlock(), _createBlock(_component_StudioToggleWithLabel, {
            key: 7,
            id: "booth-chat-toggle",
            label: "Booth Chat",
            subLabel: "Attendees can chat with other attendees in Booths.",
            class: "tw-mb-7",
            checked: _ctx.boothChatEnabled,
            "onUpdate:checked": _ctx.handleBoothChatToggle
          }, null, 8, ["checked", "onUpdate:checked"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["moduleId", "onInitializeData"]))
}